import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import env from "../services/AppEnv";
import portalConfig from "../services/PortalConfig";
import ExportProducts from "../commands/ExportProducts";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogExportButtons',
    props: {
        version: {},
        searchRequest: {},
        buttonStyle: {}
    },
    setup(__props) {
        const props = __props;
        const exportProductsCommand = (format) => {
            return new ExportProducts(props.version, props.searchRequest, format, undefined);
        };
        const exportFormats = computed(() => {
            return portalConfig.productExport.formats.filter(f => !f.requiresAuthentication || (f.requiresAuthentication && env.user.authenticated));
        });
        return (_ctx, _cache) => {
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exportFormats.value, (format, index) => {
                return (_openBlock(), _createBlock(CommandButton, {
                    key: index,
                    command: exportProductsCommand(format.name),
                    label: _ctx.$t('command.exportProducts.' + format.name),
                    classes: ['button', 'command-button', 'button--' + (__props.buttonStyle || 'outline')]
                }, null, 8, ["command", "label", "classes"]));
            }), 128));
        };
    }
});
